<template>
  <div>
    <h3>Activity Log</h3>
    <el-table :data="activity" stripe fit>
      <el-table-column label="Date" width="250">
        <template slot-scope="scope">
          {{ displayDateTime(scope.row.createdDate) }}
        </template>
      </el-table-column>
      <el-table-column prop="action" label="Action" width="250">
      </el-table-column>
      <el-table-column label="Details" width="350">
        <template slot-scope="scope">
          <div v-if="scope.row.details">
            <b>IP</b>: {{ scope.row.details.ipAddress }}<br />
            <b>Browser</b>: {{ scope.row.details.userAgent | getBrowser }}<br />
            <b>Operating System</b>: {{ scope.row.details.userAgent | getOS
            }}<br />
            <span v-if="scope.row.details.campaignName && scope.row.details.expirationDate">
              <hr />
              <b>Campaign Name</b>: {{ scope.row.details.campaignName }}<br />
              <b>Skills</b>: {{ scope.row.details.campaignSize }}<br />
              <b>Campaign Exp. Date</b>:
              {{ displayDate(scope.row.details.expirationDate) }}<br />
            </span>
            <span v-if="scope.row.details.invitations">
              <hr />
              <b>Campaign Name</b>: {{ scope.row.details.campaignName }}<br />
              <b>invitations</b>: {{ scope.row.details.invitations }}<br />
            </span>
            <span v-if="scope.row.details.assessmentId && scope.row.details.candidateId">
              <hr />
              Recruiter has seen the report <b>{{ scope.row.details.assessmentId }}</b> of user <b>{{ scope.row.details.candidateId }}</b>
            </span>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "ActivityLog",
  props: {
    activity: {
      type: Array,
      required: true,
    },
  },
  methods: {
    isActive(end) {
      const today = moment();
      const en = moment(end);
      return today.isBefore(en);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~vars";

.ic-true,
.ic-false {
  font-size: 24px;
  font-weight: bold;
}
.ic-true {
  color: green;
}
.ic-false {
  color: red;
}

.PAID {
  color: $-color-success;
}
.FREE {
  color: $-color-warning;
}
.EXPIRED {
  color: $-color-error;
}
</style>
